module.exports = __webpack_public_path__ + "static/lahli_spinach_rustica_morning_protein_bites_FOP_560x667-58477d12f8a8a55697279b4ae57fa4a3.png";